import React from 'react';
import { User, Briefcase, Building2, Mail, Phone, Globe } from 'lucide-react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import TextStyleButtons from './TextStyleButtons';

const Step1BasicInfo = ({ data, onChange }) => {
  const handleChange = (field, value) => {
    onChange({ ...data, [field]: value });
  };

  const formatPhone = (value) => {
    // Remove non-digits
    const digits = value.replace(/\D/g, '');
    
    // Format as +55 (XX) XXXXX-XXXX
    if (digits.length <= 2) return `+${digits}`;
    if (digits.length <= 4) return `+${digits.slice(0, 2)} (${digits.slice(2)}`;
    if (digits.length <= 9) return `+${digits.slice(0, 2)} (${digits.slice(2, 4)}) ${digits.slice(4)}`;
    return `+${digits.slice(0, 2)} (${digits.slice(2, 4)}) ${digits.slice(4, 9)}-${digits.slice(9, 13)}`;
  };

  return (
    <div className="space-y-5">
      {/* Full Name */}
      <div className="space-y-2">
        <Label htmlFor="fullName" className="flex items-center gap-2 text-slate-700">
          <User className="w-4 h-4" />
          Nome Completo
        </Label>
        <Input
          id="fullName"
          type="text"
          placeholder="João Silva"
          value={data.fullName}
          onChange={(e) => handleChange('fullName', e.target.value)}
          className="transition-all duration-200 focus:ring-2 focus:ring-blue-500/20"
        />
        <TextStyleButtons
          styles={data.fullNameStyles}
          onChange={(styles) => handleChange('fullNameStyles', styles)}
        />
      </div>

      {/* Position */}
      <div className="space-y-2">
        <Label htmlFor="position" className="flex items-center gap-2 text-slate-700">
          <Briefcase className="w-4 h-4" />
          Cargo
        </Label>
        <Input
          id="position"
          type="text"
          placeholder="Desenvolvedor Frontend"
          value={data.position}
          onChange={(e) => handleChange('position', e.target.value)}
          className="transition-all duration-200 focus:ring-2 focus:ring-blue-500/20"
        />
        <TextStyleButtons
          styles={data.positionStyles}
          onChange={(styles) => handleChange('positionStyles', styles)}
        />
      </div>

      {/* Company */}
      <div className="space-y-2">
        <Label htmlFor="company" className="flex items-center gap-2 text-slate-700">
          <Building2 className="w-4 h-4" />
          Empresa
        </Label>
        <Input
          id="company"
          type="text"
          placeholder="Empresa Tech"
          value={data.company}
          onChange={(e) => handleChange('company', e.target.value)}
          className="transition-all duration-200 focus:ring-2 focus:ring-blue-500/20"
        />
        <TextStyleButtons
          styles={data.companyStyles}
          onChange={(styles) => handleChange('companyStyles', styles)}
        />
      </div>

      {/* Email */}
      <div className="space-y-2">
        <Label htmlFor="email" className="flex items-center gap-2 text-slate-700">
          <Mail className="w-4 h-4" />
          Email
        </Label>
        <Input
          id="email"
          type="email"
          placeholder="joao@empresa.com"
          value={data.email}
          onChange={(e) => handleChange('email', e.target.value)}
          className="transition-all duration-200 focus:ring-2 focus:ring-blue-500/20"
        />
      </div>

      {/* Phone */}
      <div className="space-y-2">
        <Label htmlFor="phone" className="flex items-center gap-2 text-slate-700">
          <Phone className="w-4 h-4" />
          Telefone
        </Label>
        <Input
          id="phone"
          type="tel"
          placeholder="+55 (11) 99999-9999"
          value={data.phone}
          onChange={(e) => handleChange('phone', formatPhone(e.target.value))}
          className="transition-all duration-200 focus:ring-2 focus:ring-blue-500/20"
        />
      </div>

      {/* Website */}
      <div className="space-y-2">
        <Label htmlFor="website" className="flex items-center gap-2 text-slate-700">
          <Globe className="w-4 h-4" />
          Website
        </Label>
        <Input
          id="website"
          type="url"
          placeholder="www.empresa.com"
          value={data.website}
          onChange={(e) => handleChange('website', e.target.value)}
          className="transition-all duration-200 focus:ring-2 focus:ring-blue-500/20"
        />
      </div>
    </div>
  );
};

export default Step1BasicInfo;
